import { useCallback } from 'react'
import { NavigateOptions, To, useNavigate } from 'react-router-dom'

type AppNavigateFunction = (to: To, options?: NavigateOptions) => void

export type AppNavigatePartialState = {
  isNavigated?: boolean
}

/**
 * @returns wrapped navigate function that sets replace: true
 * to avoid adding entries to the history stack.
 */
export const useAppNavigate = (): AppNavigateFunction => {
  const navigate = useNavigate()

  const appNavigate = useCallback(
    (to: To, options?: NavigateOptions) => {
      // NOTE: isNavigated is used to differentiate between
      // explicit navigation vs page reload
      const state = {
        ...options?.state,
        isNavigated: true,
      }

      const navigateOptions = {
        ...options,
        state,
      }

      navigate(to, { ...navigateOptions, replace: true })
    },
    [navigate]
  )

  return appNavigate
}
